class Extranet.Views.EventManagerView extends Backbone.View

  triggerEvent: (eventName, data) ->
    @trigger eventName, data
